import { PrivacyPolicy, CreatePrivacyPolicyRequest } from "../types/working-model";
import { Get, Post, Put } from "./helpers";

export function GetPrivacyPolicy(privacy_policy: number): Promise<PrivacyPolicy> {
	return Get(`/v3/admin/events/privacy-policy/${privacy_policy}`, "");
}

export function CreatePrivacyPolicy(newPolicy: CreatePrivacyPolicyRequest, token: string): Promise<PrivacyPolicy> {
	return Post(`/v3/admin/events/privacy-policy`, token, newPolicy);
}

export function UpdatePrivacyPolicy({ privacy_policy, content, settings }: PrivacyPolicy, token: string): Promise<PrivacyPolicy> {
	return Put(`/v3/admin/events/privacy-policy/${privacy_policy}`, token, { content, settings }, true);
}
